import { useFeatureFlagEnabled } from 'posthog-js/react';

export const CONVERSATIONS_FLAG = 'conversations_tab';

const POSTHOG_ENABLED = import.meta.env.REACT_APP_POSTHOG_ENABLED === 'true';

export default function useCanAccessConversations(): boolean {
  const isEnabled = useFeatureFlagEnabled(CONVERSATIONS_FLAG);

  return POSTHOG_ENABLED ? !!isEnabled : true;
}
